import dayjs from 'dayjs';
import {
  AllowLateReservation,
  AllowReservationWhenFull,
} from '../../../../@interfaces/shop-setting';
import {
  IDate,
  ReservedSlotCapacity,
  toDayjs,
} from '../../../../core/types/reservation-types';

export type DirectContactInfo = {
  allowLateReservation: AllowLateReservation;
  allowReservationWhenFull: AllowReservationWhenFull;
  contactLineId: string | null;
  contactTelNumber: string | null;
};

export const isSlotFull = (
  date: IDate,
  slot: ReservedSlotCapacity,
  allowReservationWhenFull: AllowReservationWhenFull
) => {
  const isBeforeNow = dayjs().isAfter(
    toDayjs(date)
      .hour(slot.slot.timeRange.end.hour)
      .minute(slot.slot.timeRange.end.minute)
  );

  // リソース制約が適用されている場合の判定
  if (slot.resourceCapacity) {
    // リソースが稼働していない（休み）場合はTEL表示しない
    if (
      slot.resourceCapacity.total === 0 &&
      !slot.resourceCapacity.isFullyBooked
    ) {
      return false;
    }
    // リソースが満席の場合はTEL表示する
    if (
      slot.resourceCapacity.total === 0 &&
      slot.resourceCapacity.isFullyBooked
    ) {
      return (
        (allowReservationWhenFull === 'tel' ||
          allowReservationWhenFull === 'line') &&
        !slot.capacity.startNotAllowed &&
        (slot.capacity.initialTotal ?? 0) > 0 &&
        !isBeforeNow
      );
    }
  }

  // 従来の判定ロジック
  return (
    (allowReservationWhenFull === 'tel' ||
      allowReservationWhenFull === 'line') &&
    !slot.reserved.canReserve &&
    (slot.reserved.total > 0 || slot.capacity.total === 0) &&
    !slot.capacity.startNotAllowed &&
    (slot.capacity.initialTotal ?? 0) > 0 &&
    !isBeforeNow
  );
};

export const isSlotLate = (
  date: IDate,
  slot: ReservedSlotCapacity,
  allowLateReservation: AllowLateReservation
) => {
  const isBeforeNow = dayjs().isAfter(
    toDayjs(date)
      .hour(slot.slot.timeRange.start.hour)
      .minute(slot.slot.timeRange.start.minute)
  );

  return (
    (allowLateReservation === 'tel' || allowLateReservation === 'line') &&
    slot.reserved.canReserve &&
    (slot.capacity.initialTotal ?? 0) > 0 &&
    !isBeforeNow
  );
};
